import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { SiteFooter } from "@/components/shared/SiteFooter";
import { LegalMarkdown } from "@/components/legal/LegalMarkdown";

// The document carries its own title, dates and version, so the page adds navigation only.
export const LegalDocumentPage = ({ markdown, testId }) => {
  return (
    <div className="min-h-screen bg-background" data-testid={testId}>
      <main className="px-6 py-12">
        <div className="mx-auto flex max-w-4xl flex-col gap-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <Link to="/" data-testid={`${testId}-back-link`}>
              <Button variant="ghost" className="gap-2" data-testid={`${testId}-back-button`}>
                <ArrowLeft className="h-4 w-4" />
                Volver a Voxara
              </Button>
            </Link>
          </div>

          <Card className="border-border bg-card p-6 md:p-8">
            <span
              className="inline-flex rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-primary"
              data-testid={`${testId}-eyebrow`}
            >
              Documento legal
            </span>

            <div className="mt-5" data-testid={`${testId}-sections`}>
              <LegalMarkdown markdown={markdown} />
            </div>
          </Card>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};
